// src/actions.js

export const setNearUserData = (data) => {
    return {
      type: 'SET_NEAR_USER_DATA',
      payload: data
    };
  };
  